module.exports = __webpack_public_path__ + "media/packs/landing_page/images/activities/11-96851a49e797798d9894ed9569144030.png";